<template>
    <div :class="containerClass" @click="onWrapperClick">
        <AppTopBar @menu-toggle="onMenuToggle" />

        <transition name="layout-sidebar">
            <div :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
<!--                <div class="layout-logo">-->
<!--                    <router-link to="/">-->
<!--                        <img alt="Logo" :src="logo" />-->
<!--                    </router-link>-->
<!--                </div>-->
                <AppProfile />
                <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
            </div>
        </transition>

        <div id="app"  class="layout-main">
            <router-view />
        </div>

    </div>
</template>

<script>
    import AppTopBar from './AppTopbar.vue';
    import AppProfile from './AppProfile.vue';
    import AppMenu from './AppMenu.vue';

    export default {
        data() {
            return {
                layoutMode: 'static',
                layoutColorMode: 'dark',
                staticMenuInactive: false,
                overlayMenuActive: false,
                mobileMenuActive: false,
                menuAdmin : [
                    {label: 'Home', icon: 'pi pi-fw pi-home', to: '/'},
                    {
                        label: 'Overview', icon: 'pi pi-fw pi-sitemap',
                        items: [
                            {label: 'Staff', to: '/staff'},
                            {label: 'Curriculum Vitae', to: '/cv'},
                            {label: 'Academics', to: '/academics'},
                            {label: 'Professionals', to: '/professionals'},
                            {label: 'Trainings', to: '/trainings'},
                        ]
                    },
                    {label: 'My Details', icon: 'pi pi-fw pi-user', to: '/me'},
                ],
                menuUser: [
                    {label: 'Home', icon: 'pi pi-fw pi-home', to: '/'},
                    {label: 'My Details', icon: 'pi pi-fw pi-user', to: '/me'},
                ]
            }
        },
        watch: {
            $route() {
                this.menuActive = false;
                this.$toast.removeAllGroups();
            }
        },
        methods: {
            onWrapperClick() {
                if (!this.menuClick) {
                    this.overlayMenuActive = false;
                    this.mobileMenuActive = false;
                }

                this.menuClick = false;
            },
            onMenuToggle() {
                this.menuClick = true;

                if (this.isDesktop()) {
                    if (this.layoutMode === 'overlay') {
                        if(this.mobileMenuActive === true) {
                            this.overlayMenuActive = true;
                        }

                        this.overlayMenuActive = !this.overlayMenuActive;
                        this.mobileMenuActive = false;
                    }
                    else if (this.layoutMode === 'static') {
                        this.staticMenuInactive = !this.staticMenuInactive;
                    }
                }
                else {
                    this.mobileMenuActive = !this.mobileMenuActive;
                }

                event.preventDefault();
            },
            onSidebarClick() {
                this.menuClick = true;
            },
            onMenuItemClick(event) {
                if (event.item && !event.item.items) {
                    this.overlayMenuActive = false;
                    this.mobileMenuActive = false;
                }
            },
            onLayoutChange(layoutMode) {
                this.layoutMode = layoutMode;
            },
            onLayoutColorChange(layoutColorMode) {
                this.layoutColorMode = layoutColorMode;
            },
            addClass(element, className) {
                if (element.classList)
                    element.classList.add(className);
                else
                    element.className += ' ' + className;
            },
            removeClass(element, className) {
                if (element.classList)
                    element.classList.remove(className);
                else
                    element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            },
            isDesktop() {
                return window.innerWidth > 1024;
            },
            isSidebarVisible() {
                if (this.isDesktop()) {
                    if (this.layoutMode === 'static')
                        return !this.staticMenuInactive;
                    else if (this.layoutMode === 'overlay')
                        return this.overlayMenuActive;
                    else
                        return true;
                }
                else {
                    return true;
                }
            },
        },
        computed: {
            menu() {
                return this.$store.state.isAdmin ? this.menuAdmin : this.menuUser;
            },
            containerClass() {
                return ['layout-wrapper', {
                    'layout-overlay': this.layoutMode === 'overlay',
                    'layout-static': this.layoutMode === 'static',
                    'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                    'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                    'layout-mobile-sidebar-active': this.mobileMenuActive,
                }];
            },
            sidebarClass() {
                return ['layout-sidebar', {
                    'layout-sidebar-dark': this.layoutColorMode === 'dark',
                    'layout-sidebar-light': this.layoutColorMode === 'light'
                }];
            },
            logo() {
                return (this.layoutColorMode === 'dark') ? "assets/layout/images/logo-white.svg" : "assets/layout/images/logo.svg";
            }
        },
        beforeUpdate() {
            if (this.mobileMenuActive)
                this.addClass(document.body, 'body-overflow-hidden');
            else
                this.removeClass(document.body, 'body-overflow-hidden');
        },
        components: {
            'AppTopBar': AppTopBar,
            'AppProfile': AppProfile,
            'AppMenu': AppMenu,
        }
    }
</script>

<style lang="scss">
    @import "~primevue/resources/themes/saga-blue/theme.css";
    @import "~primevue/resources/primevue.min.css";
    @import "~primeicons/primeicons.css";
    @import "~primeflex/primeflex.css";
    @import './assets/layout/layout.scss';
    @import './assets/layout/flags/flags.css';

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>
